import { createContext, PropsWithChildren } from 'react';
import { WorkspacePanel } from './workspace-panel';

export const WorkspacePanelContext = createContext<WorkspacePanel | undefined>(undefined);

export function WorkspacePanelProvider({
    workspacePanel,
    children,
}: PropsWithChildren<{
    workspacePanel: WorkspacePanel;
}>): React.ReactElement {
    return (
        <WorkspacePanelContext.Provider value={workspacePanel}>
            {children}
        </WorkspacePanelContext.Provider>
    );
}
